import { h, render } from 'preact';
import { FormattedMessage } from 'react-intl';

import { HOST_WEB_PRODUCTION, HOST_WEB_STAGING } from 'utils/constants';

import Button from 'components/Button';
import Column from 'components/Column';
import ContainerAd from 'components/Container/ContainerAd';
import ContentAd from 'components/Content/ContentAd';
import Footer from 'components/Footer';
import H2 from 'components/H2';
import H3 from 'components/H3';
import Img from 'components/Img';
import PAd from 'components/P/PAd';

import messages from './messages';

const WasiatIcon = "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/wasiat-icon.svg"
const HOST = process.env.PREACT_APP_API_URL === 'production' ? HOST_WEB_PRODUCTION : HOST_WEB_STAGING;

function onClickCTA(props) {
  const location = props.matches.location;
  const category = props.matches.category;
  const url = props.matches.url;
  const version = props.matches.version;
  const cohort = props.matches.cohort;

  if (!location) return HOST + "/faq/wasiat/?welcome_page=true&utm_source=hukumonline&utm_medium=iframe&utm_campaign=Wasiat&utm_content=uncategorized&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  if (location.includes("summary")) {
    return HOST + "/faq/wasiat/?welcome_page=true&utm_source=hukumonline&utm_medium=iframe&utm_campaign=Wasiat&utm_content=intisari&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location === "ulasan-top") {
    return HOST + "/faq/wasiat/?welcome_page=true&utm_source=hukumonline&utm_medium=iframe&utm_campaign=Wasiat&utm_content=ulasan1&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location == "ulasan-bottom") {
    return HOST + "/faq/wasiat/?welcome_page=true&utm_source=hukumonline&utm_medium=iframe&utm_campaign=Wasiat&utm_content=ulasan2&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else {
    return HOST + "/faq/wasiat/?welcome_page=true&utm_source=hukumonline&utm_medium=iframe&utm_campaign=Wasiat&utm_content=uncategorized&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  }
}

const Wasiat = (props) => {
  return (
    <ContainerAd>
      <ContentAd>
        <br />
        <H2 style={{ margin: "0", }}>
          {"Siapkan Wasiat Dari Sekarang,"}<br /> {"Keluarga Bisa Tenang"}
        </H2>
        <PAd>
          <FormattedMessage {...messages.description} />
        </PAd>
        <Img style={{ height: '60px', width: '60px', margin: '10px 0 0' }} src={WasiatIcon} alt="Wasiat Icon" />
        <H3 style={{ fontSize: '20px', margin: '0px', color: "#003366" }}>{"Rp75.000"}</H3>
        <Column width="2" style={{ margin: "0" }}>
          <Button
            href={onClickCTA(props)}
            blank="_blank"
            color='yellow'
            size="large"
          >
            <FormattedMessage {...messages.cta} />
          </Button>
        </Column>
        <br />
        <Footer />
      </ContentAd>
    </ContainerAd>
  )
}

export default Wasiat;